class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  cartDiscounts() {

    // let clearBtn = document.querySelector('#clear-discount-btn');
    // let applyBtn = document.querySelector('#apply-discount-btn');
    // let discountCodeError = document.querySelector('#discount-code-error');
    // let discountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');
    // let discountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');
    // let discountCodeInput = document.querySelector('#discount-code-input');
    // let totalCartSelector = document.querySelector('.cart__subtotal .money'); // Total Cart Selector to update the total amount.
    // let authorization_token;
    // const toggleOpen = document.querySelector('.cart-discount-acordian__header');

    // if (!clearBtn) {
    //   return;
    // }

    // toggleOpen.addEventListener('click', function () {
    //   this.parentNode.classList.toggle('active');
    // });

    // let checkoutContainer = document.createElement('div');
    // document.body.appendChild(checkoutContainer);
    // if (localStorage.discountCode) applyDiscount(JSON.parse(localStorage.discountCode).code);
    // if (applyBtn)
    //   applyBtn.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     applyDiscount(discountCodeInput.value);
    //   });
    // if (clearBtn)
    //   clearBtn.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     clearDiscount();
    //   });
    // function clearDiscount() {
    //   discountCodeValue.innerHTML = '';
    //   discountCodeError.innerHTML = '';
    //   clearLocalStorage();
    //   fetch('/checkout?discount=%20');
    // }
    // function clearLocalStorage() {
    //   if (discountCodeWrapper) discountCodeWrapper.style.display = 'none';
    //   if (totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
    //   localStorage.removeItem('discountCode');
    // }
    // function applyDiscount(code) {
    //   if (applyBtn) {
    //     applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
    //     applyBtn.style.pointerEvents = 'none';
    //   }
    //   fetch('/payments/config', { method: 'GET' })
    //     .then(function (response) {
    //       return response.json();
    //     })
    //     .then(function (data) {
    //       const checkout_json_url = '/wallets/checkouts/';
    //       authorization_token = btoa(data.paymentInstruments.accessToken);
    //       fetch('/cart.js', {})
    //         .then(function (res) {
    //           return res.json();
    //         })
    //         .then(function (data) {
    //           let body = {
    //             checkout: {
    //               country: Shopify.country,
    //               discount_code: code,
    //               line_items: data.items,
    //               presentment_currency: Shopify.currency.active,
    //             },
    //           };
    //           fetch(checkout_json_url, {
    //             headers: {
    //               accept: '*/*',
    //               'cache-control': 'no-cache',
    //               authorization: 'Basic ' + authorization_token,
    //               'content-type': 'application/json, text/javascript',
    //               pragma: 'no-cache',
    //               'sec-fetch-dest': 'empty',
    //               'sec-fetch-mode': 'cors',
    //               'sec-fetch-site': 'same-origin',
    //             },
    //             referrerPolicy: 'strict-origin-when-cross-origin',
    //             method: 'POST',
    //             mode: 'cors',
    //             credentials: 'include',
    //             body: JSON.stringify(body),
    //           })
    //             .then(function (response) {
    //               return response.json();
    //             })
    //             .then(function (data) {
    //               console.log(data.checkout);
    //               if (data.checkout && data.checkout.applied_discounts.length > 0) {
    //                 let discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkout/';
    //                 fetch(discountApplyUrl, {}).then(function (response) {
    //                   return response.text();
    //                 });
    //                 if (discountCodeWrapper) discountCodeWrapper.style.display = 'inline';
    //                 if (discountCodeError) discountCodeError.innerHTML = '';
    //                 if (discountCodeValue)
    //                   discountCodeValue.innerHTML =
    //                     data.checkout.applied_discounts[0].title +
    //                     ' (' +
    //                     data.checkout.applied_discounts[0].amount +
    //                     ' ' +
    //                     Shopify.currency.active +
    //                     ')';
    //                 let localStorageValue = {
    //                   code: code.trim(),
    //                   totalCart: data.checkout.total_line_items_price,
    //                 };
    //                 localStorage.setItem('discountCode', JSON.stringify(localStorageValue));
    //                 if (totalCartSelector)
    //                   totalCartSelector.innerHTML =
    //                     '<s>' + data.checkout.total_line_items_price + '</s>' + data.checkout.total_price;
    //               } else {
    //                 if (discountCodeValue) discountCodeValue.innerHTML = '';
    //                 clearLocalStorage();
    //                 if (discountCodeError) discountCodeError.innerHTML = 'Please Enter Valid Coupon Code.';
    //               }
    //             })
    //             .finally(function (params) {
    //               if (applyBtn) {
    //                 applyBtn.innerHTML = 'APPLY';
    //                 applyBtn.style.pointerEvents = 'all';
    //               }
    //             });
    //         });
    //     });
    // }

  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.cart-discount-acordian'];
          for (const selector of selectors) {

            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);

            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          this.cartDiscounts()
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        this.cartDiscounts()
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Mystery Bundle Remove Button - handles removal of grouped mystery bundle items
class MysteryBundleRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.removeMysterBundle();
    });
  }

  async removeMysterBundle() {
    const variantKeys = this.dataset.variantKeys;
    if (!variantKeys) {
      console.error('No variant keys found for mystery bundle removal');
      return;
    }

    const keys = variantKeys.split(',');
    console.log('🗑️ Removing mystery bundle variants:', keys);

    // Show loading state
    const button = this.querySelector('button');
    const originalText = button.textContent;
    button.textContent = 'Removing...';
    button.disabled = true;

    try {
      // Create FormData for cart update (same as normal cart operations)
      const formData = new FormData();
      keys.forEach(key => {
        formData.append(`updates[${key}]`, '0');
      });

      // Remove all mystery bundle variants using cart update
      const response = await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to remove mystery bundle');
      }

      // Force page refresh after successful removal (simple and reliable)
      console.log('✅ Mystery bundle removed successfully - refreshing page');
      window.location.reload();

    } catch (error) {
      console.error('❌ Error removing mystery bundle:', error);
      
      // Show error message
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'There was an error removing the mystery bundle. Please try again.';
      }
      
      // Reset button
      button.textContent = originalText;
      button.disabled = false;
    }
  }
}

customElements.define('mystery-bundle-remove-button', MysteryBundleRemoveButton);
